var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RequestWizardStep',{attrs:{"name":"Request Type","complete":_vm.requestType !== null}},[_c('ContentCard',{attrs:{"title":"OK! Now please tell us a little more about the records request you are making."}},[_c('ReflectAttrs',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var requestTypeLabel = ref.requestTypeLabel;
return [_c('div',[_c('p',{staticClass:"lead"},[_vm._v(_vm._s(requestTypeLabel)+":")]),_c('StepSelection',[_c('RadioButtons',{attrs:{"aria-label":requestTypeLabel,"options":[
              {
                value: 'general',
                label: 'General records request (ex. Correspondence, Emails, Calendars,'
                  + ' Presentation Materials, Reports)'
              },
              {
                value: 'firstParty',
                label: 'Personal records request (ex. Your personnel file or records about you)'
              },
              {
                value: 'thirdParty',
                label: 'Records on another\'s behalf (ex. You represent someone or have'
                  + ' authorization to act on another\'s behalf and you seek the individual\'s'
                  + ' personnel file or records about them)'
              }
            ]},model:{value:(_vm.requestType),callback:function ($$v) {_vm.requestType=$$v},expression:"requestType"}})],1)],1)]}}])},'ReflectAttrs',{ requestTypeLabel: 'I am making a' },false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }